<script>
  import NaPictureRegular from "$lib/components/global/Na_Picture_Regular.svelte";
  
  /**@type {import ("$lib/types").MediaQueryImages}*/ 
  export let images;
  /**@type {string}*/
  export let title;
  /**@type {string}*/
  export let link;
</script>
<a href={link} class="card">
   <div class="imagen">
          <NaPictureRegular mediaQueryImages={images}  radius={20} />
   </div>
   <p>{title}</p>
</a>

<style>
  .card{
    min-width: 180px;
    width: 180px;
    aspect-ratio: 9/16;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    gap: 2px;
  }
  .card .imagen{
      width: 100%;
      height: 90%;
  }
  .card p {
    text-transform: uppercase;
    text-align: center;
    font-size: 0.95rem;
    width: 95%;
 }
</style>